import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "authentication-login-group" }
const _hoisted_2 = { class: "side" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "side-text-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "welcome-text text-uppercase" }, "Welcome To"),
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo",
      src: "/images/auth/login-logo.png",
      alt: ""
    })
  ])
], -1)
const _hoisted_4 = { class: "switch" }
const _hoisted_5 = {
  class: "text-uppercase",
  style: {"margin-right":"18px"}
}
const _hoisted_6 = {
  class: "text-uppercase",
  style: {"margin-left":"5px"}
}
const _hoisted_7 = {
  class: "form-container",
  style: {"min-height":"850px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mobile-logo",
    src: "/images/auth/login-logo.png",
    alt: ""
  })
], -1)
const _hoisted_9 = { class: "auth-language-dropdown" }
const _hoisted_10 = { class: "mb-10 mt-lg-0 mt-10" }
const _hoisted_11 = {
  class: "mb-3",
  style: {"color":"#000000e0"}
}
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = { class: "col-lg-6" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-4" }
const _hoisted_20 = { class: "col-8" }
const _hoisted_21 = { class: "row mb-10" }
const _hoisted_22 = { class: "col-lg-12" }
const _hoisted_23 = {
  class: "",
  style: {"margin":"0 auto"}
}
const _hoisted_24 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_25 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_27 = {
  class: "text-center mt-5",
  style: {"font-size":"16px"}
}

import { ref, onMounted, reactive } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import GlobalService from "@/projects/client/services/ClientGlobalService";
import PhoneCountryData from "@/core/data/phonesData";
import LanguageDropdown from "../../components/LanguageDropdown.vue";
import AuthSwitch from "@/projects/client/components/AuthSwitch.vue";
import { type FormRules, FormInstance } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeadCreate',
  setup(__props) {

const store = useStore();
const router = useRouter();
const isLoading = ref(false);

const contryCode = ref("");
const leadFormRef = ref<FormInstance>();
const submitButton = ref<HTMLButtonElement | null>(null);
const phoneCountryData = ref(PhoneCountryData);

const formData = ref({
  name: "",
  email: "",

  phoneNumber: "",
  note: "",
});

const formRule = reactive({
  name: [
    {
      required: true,
      message: "Please enter your name",
      trigger: "blur",
    },
  ],
  email: [
    {
      required: true,
      message: "Please enter your email",
      trigger: "blur",
    },
    {
      type: "email",
      message: "Please enter a correct email",
      trigger: "blur",
    },
  ],
  countryCode: [
    {
      required: false,
      message: "Please select your country",
      trigger: "blur",
    },
  ],
  phone: [
    {
      required: false,
      type: "number",
      message: "Please enter your phone number",
      trigger: "blur",
    },
  ],
  note: [
    {
      required: true,
      message: "Please enter your notes",
      trigger: "blur",
    },
  ],
});

onMounted(() => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
});

const authType = ref(false);
const toggleAuthType = (_authType) => {
  authType.value = _authType;
  router.push({ name: "sign-up" });
};

const submit = async (formEl: FormInstance | undefined) => {
  isLoading.value = true;

  try {
    await formEl?.validate((valid) => {
      if (valid) {
        if (contryCode.value !== "" && formData.value.phoneNumber !== "") {
          formData.value.phoneNumber =
            contryCode.value + formData.value.phoneNumber;
        }

        GlobalService.createLead(formData.value);
        Swal.fire({
          text: "We have received your information and will contact you soon.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Ok!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-primary",
          },
        }).then(function () {
          // Go to page after successfully login
          router.push("/");
        });
      }
    });
  } catch (error: any) {
    Swal.fire({
      text: error.message,
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: "Try again!",
      customClass: {
        confirmButton: "btn fw-semobold btn-light-danger",
      },
    });
  }

  isLoading.value = false;
};

const onSubmitCreate = async (values) => {
  if (!submitButton.value) {
    return;
  }

  submitButton.value.disabled = true;
  submitButton.value.setAttribute("data-kt-indicator", "on");

  values.confirmUrl = "temporaryConfirmUrl";

  // Send register request
  try {
    await GlobalService.createLead(formData.value);
    Swal.fire({
      text: "We have received your information and will contact you soon.",
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: "Ok!",
      customClass: {
        confirmButton: "btn fw-semobold btn-light-primary",
      },
    }).then(function () {
      // Go to page after successfully login
      router.push("/");
    });
  } catch (error: any) {
    Swal.fire({
      text: error.message,
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: "Try again!",
      customClass: {
        confirmButton: "btn fw-semobold btn-light-danger",
      },
    });
  }

  submitButton.value.disabled = false;
  submitButton.value.setAttribute("data-kt-indicator", "off");
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("action.login")), 1),
        _createVNode(AuthSwitch, {
          isEnabled: authType.value,
          color: "#F5BF21",
          onToggleAuthType: toggleAuthType
        }, null, 8, ["isEnabled"]),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("action.register")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(LanguageDropdown)
      ]),
      _createVNode(_component_el_form, {
        class: "px-10 px-lg-0",
        id: "kt_register_signup_form",
        model: formData.value,
        rules: formRule,
        ref_key: "leadFormRef",
        ref: leadFormRef,
        style: {"min-width":"200px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t("title.contactUs")), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_form_item, { prop: "name" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    size: "large",
                    modelValue: formData.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                    placeholder: _ctx.$t('fields.fullName')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_form_item, { prop: "email" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    size: "large",
                    modelValue: formData.value.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                    placeholder: _ctx.$t('fields.email')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_form_item, { prop: "countryCode" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: contryCode.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contryCode).value = $event)),
                    placeholder: _ctx.$t('tip.selectCountry'),
                    size: "large",
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phoneCountryData.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          value: item.dialCode,
                          label: item.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_el_input, {
                    modelValue: contryCode.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contryCode).value = $event)),
                    size: "large",
                    readonly: true
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_form_item, { prop: "phone" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "tel",
                        modelValue: formData.value.phoneNumber,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.phoneNumber) = $event)),
                        size: "large",
                        placeholder: _ctx.$t('fields.phone')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_el_form_item, { prop: "note" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.note,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.note) = $event)),
                    autosize: { minRows: 2, maxRows: 12 },
                    type: "textarea",
                    size: "large",
                    placeholder: _ctx.$t('fields.notes')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              class: "btn btn-lg w-100 loginBtn",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (submit(leadFormRef.value)), ["prevent"]))
            }, [
              (!isLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t("action.sendToUs")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_25, [
                    _createTextVNode(" Please wait... "),
                    _hoisted_26
                  ]))
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_router_link, { to: "/sign-in" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.backToLogin")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})